import React, { useEffect, useState } from "react";
import FullPageGame from "./FullPageGame";
import { useSelector, useDispatch } from "react-redux";
import { openLoginModal } from "../../../../redux/authSlice";
import { BsShieldLockFill } from "react-icons/bs";

const BTiPage = () => {
    const { user } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    if (!user) {
        return (
            <div style={{
                height: "100%",
                width: "100%",
                background: "#0b0b0f",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "20px"
            }}>
                <div style={{
                    padding: "40px",
                    background: "#1a1a1a",
                    borderRadius: "16px",
                    textAlign: "center",
                    maxWidth: "400px",
                    width: "90%",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.5)"
                }}>
                    <BsShieldLockFill size={48} color="#ff9900" style={{ marginBottom: "20px" }} />
                    <h2 style={{ fontSize: "1.8rem", fontWeight: "bold", marginBottom: "10px" }}>Login Required</h2>
                    <p style={{ color: "#aaa", marginBottom: "30px" }}>Please login to access BTi Sports.</p>
                    <button
                        onClick={() => dispatch(openLoginModal())}
                        style={{
                            background: "linear-gradient(90deg, #ff9900 0%, #ff5e00 100%)",
                            color: "white",
                            border: "none",
                            padding: "14px 30px",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderRadius: "8px",
                            cursor: "pointer",
                            width: "100%",
                            transition: "transform 0.2s",
                        }}
                        onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                        onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                        Login Now
                    </button>
                </div>
            </div>
        );
    }

    return (
        <FullPageGame
            gameId="698e2142e37eed02693e9d71"
            pageTitle="BTi Sports"
        />
    );
};

export default BTiPage;
